/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
setInterval(function(){
  $('[data-close-button]').click(function(){
    $(this).parent().removeClass('is-active')
    if($(window).width() < 767){
    $(this).parent().removeClass('is-active').hide()
    $('.quick-add-modal__overlay').remove()
    $('body').removeClass('stop-scrolling')
    }
  })
},500)